<div class="list-container">
  @if (leverantorer) {
    <span>Sökresultat: {{ leverantorer.length }} träffar</span>
  }
  <rask-list [virtualScroll]="true" virtualScrollType="window" [virtualScrollItemHeight]="48" [data]="leverantorer">
    <rask-list-column header="{{ 'LEVERANTOR_HEADER_LEVERANTOR' | translate }}" field="namn" [sortable]="true">
      <ng-template let-row="row">
        <a href="#" (click)="openRedigeraLeverantorDialog($event, row.id)">{{ row.namn }}</a>
      </ng-template>
    </rask-list-column>
    <rask-list-column header="{{ 'LEVERANTOR_LABEL_ORGNR' | translate }}" field="orgnr" [sortable]="true" [nowrap]="true"></rask-list-column>
    <rask-list-column header="{{ 'LEVERANTOR_LABEL_LIMEID' | translate }}" field="limeId" [sortable]="true"></rask-list-column>
    <rask-list-column header="{{ 'LEVERANTOR_LABEL_ADRESS' | translate }}" field="adress" [sortable]="true" [tooltip]="true"></rask-list-column>
    <rask-list-column header="{{ 'LEVERANTOR_LABEL_TELEFON' | translate }}" field="telefonnummer" [sortable]="true"></rask-list-column>
    <rask-list-column header="{{ 'LEVERANTOR_LABEL_EPOST' | translate }}" field="epost" [sortable]="true">
      <ng-template let-row="row">
        @if (isEmailValid(row.epost)) {
          <a [href]="'mailto:' + row.epost | raskSafe">{{row.epost}}</a>
        } @else {
          {{row.epost}}
        }
      </ng-template>
    </rask-list-column>
    <rask-list-column header="{{ 'LEVERANTOR_LABEL_ANSV_VIRKESKOPARE' | translate }}" [sortable]="true" [nowrap]="true" field="ansvarigVirkeskopare"></rask-list-column>
    <rask-list-column header="Klassning" [sortable]="true" field="klassning"></rask-list-column>
    <rask-list-column header="Leverantörsstatus" [sortable]="true" field="leverantorsstatus"></rask-list-column>
  </rask-list>
</div>